import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type TimeEntryItem = {
  id: string;
  sessionId: string;
  userId: number;
  category: string;
  categoryColor: string;
  todoId: string | null;
  todoTitle: string | null;
  note: string | null;
  startTime: string;
  endTime: string;
  duration: number;
  createdAt: string | null;
  sessionName: string | null;
};

export type OutputType = {
  entries: TimeEntryItem[];
};

export const getTimeEntriesList = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams();
  if (input.sessionId) params.append('sessionId', input.sessionId);
  if (input.dateFrom) params.append('dateFrom', input.dateFrom);
  if (input.dateTo) params.append('dateTo', input.dateTo);

  const result = await fetch(`/_api/time-entries/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
